import React from 'react';
import { Loader } from 'lucide-react';

export function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center p-4">
      <Loader className="h-8 w-8 text-blue-600 animate-spin" />
      <p className="mt-2 text-sm text-gray-600">Loading...</p>
    </div>
  );
}